module.exports = __webpack_public_path__ + "static/media/tile-price-2.f23fddda.jpg";